import './em.scss';

class EmForm {
    constructor(element) {
        this.$root = element;
        this.$form = this.$root.querySelector('[data-form="root"]');
        this.$nextButton = this.$root.querySelector('[data-em-nav="next"]');
    }

    initialize() {
        this.setEvents();
        this.scrollToFirstError();
    }

    setEvents() {
        if (!this.$form) {
            return;
        }

        if (this.$nextButton) {
            this.$nextButton.addEventListener('click', (event) => {
                this.submitForm(event);
            });
        }

        this.setupKeyboardSupport();
    }
    
    scrollToFirstError() {
        const firstErrorField = this.$root.querySelector('.form__field--error');

        if (!firstErrorField) {
            return;
        }

        firstErrorField.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        });

        const field = firstErrorField.querySelector('input, select, textarea');

        if (field) {
            field.focus();
        }
    }


    setupKeyboardSupport() {
        this.$form.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter') {
                return;
            }

            const activeElement = document.activeElement;

            if (
                activeElement?.type === 'checkbox' ||
                activeElement?.type === 'radio'
            ) {
                event.preventDefault();
                activeElement.click();
            }
        });
    }

    submitForm(event) {
        event.preventDefault();

        if (typeof this.$form.requestSubmit === 'function') {
            this.$form.requestSubmit();
            return;
        }

        this.$form.submit();
    }
}

export { EmForm };

window.addEventListener('content.loaded', (event) => {
    const $context = event.detail?.$context;

    if (!$context) {
        return;
    }

    const $$emForms = $context.querySelectorAll('[data-em-form="root"]');

    $$emForms.forEach(($emForm) => {
        const emForm = new EmForm($emForm);
        emForm.initialize();
    });
});